import { TravelerRole } from './Traveler'

export type TripInvitation = {
	id: string
	code: string
	itineraryId: string
	role: TravelerRole
	referralId?: string
	url?: string
	email?: string
	status?: TRIP_INVITATION_STATUS
}

export enum TRIP_INVITATION_STATUS {
	PENDING = 'pending',
	ACCEPTED = 'accepted',
	CANCELLED = 'cancelled',
}
